import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useUserContext } from '../../UserContext';
import { Grid, GridColumn, GridRow, Menu, Dropdown, Icon, Input, Checkbox } from 'semantic-ui-react';
import * as API from '../../API';
import './AnalysisGrid.scss';
const zoomLevels = [1, 2, 3, 4, 5, 6, 7];
export const AnalysisGrid = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const userContext = useUserContext();
    const tailPathFrag = (window.location.hash.split('/').pop()) || '';
    const knr = /^\d{4}/.test(tailPathFrag) ? tailPathFrag : null;
    const [cardSelection, setCardSelection] = useState(new Set());
    const [zoomLevel, setZoomLevel] = useState((_d = (_c = (_b = (_a = userContext.data) === null || _a === void 0 ? void 0 : _a.userData) === null || _b === void 0 ? void 0 : _b.analyticsRoom) === null || _c === void 0 ? void 0 : _c.zoomLevel) !== null && _d !== void 0 ? _d : 4);
    useEffect(() => { userContext.refresh(); }, []);
    const onChangeCardSelection = (data) => {
        setCardSelection((prevSelection) => {
            const newSelection = new Set(prevSelection);
            if (data.id) {
                data.checked
                    ? newSelection.add(data.id)
                    : newSelection.delete(data.id);
            }
            return newSelection;
        });
    };
    const jsxAnalysis = [
        _jsx(AnalysisGrid.Card, { create: true, knr: props.knr })
    ];
    (((_g = (_f = (_e = userContext.data) === null || _e === void 0 ? void 0 : _e.userData) === null || _f === void 0 ? void 0 : _f.analyticsRoom) === null || _g === void 0 ? void 0 : _g.analyses) || []).forEach((analysis) => {
        if (analysis.id && Number.isInteger(analysis.id)) {
            jsxAnalysis.push(_jsx(AnalysisGrid.Card, { id: analysis.id, knr: props.knr, analysis: analysis, selected: cardSelection.has(analysis.id), onChangeCardSelection: onChangeCardSelection }, `analysis-${analysis.id}`));
        }
    });
    const jsxGridContent = [];
    let jsxRowItems = [];
    for (let i = 0; i < zoomLevel * 2; i++) {
        jsxRowItems.push(jsxAnalysis[i] ? _jsx(GridColumn, { children: jsxAnalysis[i] }, `cardslot-${i}`) : _jsx(GridColumn, { children: _jsx("div", { className: "analysis-card empty" }) }, `cardslot-${i}`));
        if ((i + 1) % zoomLevel === 0) {
            jsxGridContent.push(_jsx(GridRow, { columns: zoomLevel, children: jsxRowItems }, `cardRow-${(i + 1) / (zoomLevel + 1)}`));
            jsxRowItems = [];
        }
    }
    return (_jsx(_Fragment, { children: _jsxs(Grid, { className: "analysis-grid", children: [_jsx(GridRow, { columns: 1, children: _jsx(GridColumn, { children: _jsxs("div", { className: "toolbar", children: [_jsx("div", { className: "status", children: cardSelection.size > 0 ? `${cardSelection.size} valgt` : `` }), _jsxs("div", { className: "zoom-control", children: [_jsx("label", { children: "Zoom" }), _jsx(Input, { min: 2, max: 7, onChange: (_, data) => setZoomLevel(parseInt(data.value)), type: 'range', value: zoomLevel }), _jsx("label", { children: zoomLevel * 2 })] })] }) }) }), jsxGridContent] }) }));
};
const CardMenu = (({ className, analysisId }) => {
    const userContext = useUserContext();
    const clsx = [
        'card-menu',
        className
    ].join(' ');
    const onDeleteAnalysis = (analysisId) => {
        if (analysisId !== undefined) {
            API.userspaceDeleteAnalysis(analysisId)
                .then(() => userContext.refresh());
        }
    };
    return (_jsx(Menu, { className: clsx, children: _jsx(Menu.Menu, { position: "right", children: _jsx(Dropdown, { item: true, icon: "ellipsis horizontal", simple: true, placement: "right", children: _jsxs(Dropdown.Menu, { children: [_jsxs(Dropdown.Item, { children: [_jsx(Icon, { name: "edit" }), "Rediger"] }), _jsxs(Dropdown.Item, { children: [_jsx(Icon, { name: "copy" }), "Dupliser"] }), _jsxs(Dropdown.Item, { onClick: (e, data) => onDeleteAnalysis(analysisId), children: [_jsx(Icon, { name: "trash" }), "Slett"] })] }) }) }) }));
});
const Card = Object.assign(({ className, create, id, knr, analysis, selected, onChangeCardSelection }) => {
    const clsx = [
        'analysis-card',
        className !== null && className !== void 0 ? className : '',
        create ? 'create-new' : ''
    ].join(' ');
    const onChangeSelection = (_, data) => {
        onChangeCardSelection && onChangeCardSelection(data);
    };
    const analysisBaseUrl = `#analyserommet${knr ? `/${knr}` : ``}/analyse`;
    return create ? _jsx("a", { className: clsx, href: `${analysisBaseUrl}/ny`, children: _jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", children: [_jsx("line", { x1: "15", y1: "4.37115e-08", x2: "15", y2: "30", stroke: "black", strokeWidth: "2" }), _jsx("line", { y1: "14", x2: "30", y2: "14", stroke: "black", strokeWidth: "2" })] }) })
        : _jsxs("div", { className: clsx, children: [_jsxs("header", { children: [_jsx(AnalysisGrid.Card.CardMenu, { analysisId: id }), _jsx(Checkbox, { className: "select-card", id: id, checked: selected, onChange: onChangeSelection })] }), _jsx("main", { children: _jsx("h1", { children: _jsx("a", { href: `${analysisBaseUrl}/${id}`, children: analysis === null || analysis === void 0 ? void 0 : analysis.title }) }) })] });
}, { CardMenu });
AnalysisGrid.Card = Card;
